// src/api/servicioPublico.js
import { apiFetch } from './index.js';

// ============================================================
//  CRUD SERVICIO PÚBLICO (Catálogo)
// ============================================================

export const obtenerServiciosPublicos = async () => {
  try {
    const response = await apiFetch('/api/ServicioPublico');
    return { success: true, data: Array.isArray(response) ? response : (response.data || []) };
  } catch (error) {
    console.error('❌ Error obteniendo servicios públicos:', error);
    return { success: false, error: error.message, data: [] };
  }
};

export const obtenerServiciosPublicosActivos = async () => {
  try {
    const response = await apiFetch('/api/ServicioPublico/activos');
    return { success: true, data: Array.isArray(response) ? response : (response.data || []) };
  } catch (error) {
    return { success: false, error: error.message, data: [] };
  }
};

export const obtenerServicioPublicoPorId = async (id) => {
  try {
    const response = await apiFetch(`/api/ServicioPublico/${id}`);
    return { success: true, data: response.data || response };
  } catch (error) {
    return { success: false, error: error.message, data: null };
  }
};

export const obtenerServiciosPublicosPorTipo = async (tipo) => {
  try {
    const response = await apiFetch(`/api/ServicioPublico/tipo/${tipo}`);
    return { success: true, data: Array.isArray(response) ? response : (response.data || []) };
  } catch (error) {
    return { success: false, error: error.message, data: [] };
  }
};

export const crearServicioPublico = async (data) => {
  try {
    const response = await apiFetch('/api/ServicioPublico', {
      method: 'POST',
      body: JSON.stringify(data)
    });
    return { success: true, data: response.data || response };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const actualizarServicioPublico = async (id, data) => {
  try {
    const response = await apiFetch(`/api/ServicioPublico/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
    return { success: true, data: response.data || response };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const eliminarServicioPublico = async (id) => {
  try {
    await apiFetch(`/api/ServicioPublico/${id}`, { method: 'DELETE' });
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const verificarNombreServicioPublico = async (nombre, excludeId = null) => {
  try {
    const url = excludeId
      ? `/api/ServicioPublico/nombre/${encodeURIComponent(nombre)}/exists?excludeId=${excludeId}`
      : `/api/ServicioPublico/nombre/${encodeURIComponent(nombre)}/exists`;
    const response = await apiFetch(url);
    return { success: true, existe: response.existe || false };
  } catch (error) {
    return { success: false, error: error.message, existe: false };
  }
};

// ============================================================
//  CONSTANTES Y HELPERS DE UI
// ============================================================

/**
 * Tipos disponibles para CREAR un servicio
 * (El sistema define qué tipos existen, pero los SERVICIOS en sí vienen de la BD)
 */
export const TIPOS_DISPONIBLES = [
  { value: 'agua', label: 'Agua' },
  { value: 'luz', label: 'Electricidad' },
  { value: 'internet', label: 'Internet' },
  { value: 'telefono', label: 'Teléfono' },
  { value: 'gas', label: 'Gas' },
  { value: 'cable', label: 'Cable/TV' },
  { value: 'aseo', label: 'Aseo' },
  { value: 'otro', label: 'Otro' }
];

/**
 * Colores por defecto por tipo (fallback si la BD no trae color)
 */
export const COLORES_FALLBACK = {
  agua: '#00bcd4',
  luz: '#ffc107',
  internet: '#2196f3',
  telefono: '#4caf50',
  gas: '#ff5722',
  cable: '#9c27b0',
  aseo: '#607d8b',
  otro: '#795548'
};

/**
 * Iconos por defecto por tipo (fallback si la BD no trae icono)
 */
export const ICONOS_FALLBACK = {
  agua: 'mdi:water',
  luz: 'mdi:lightning-bolt',
  internet: 'mdi:wifi',
  telefono: 'mdi:phone',
  gas: 'mdi:fire',
  cable: 'mdi:television',
  aseo: 'mdi:trash-can',
  otro: 'mdi:file-document'
};

/**
 * Devuelve el color del servicio (de la BD o fallback)
 */
export const getColorServicio = (servicio) => {
  if (!servicio) return COLORES_FALLBACK.otro;
  return servicio.color || COLORES_FALLBACK[servicio.tipo_servicio] || COLORES_FALLBACK.otro;
};

/**
 * Devuelve el icono del servicio (de la BD o fallback)
 */
export const getIconoServicio = (servicio) => {
  if (!servicio) return ICONOS_FALLBACK.otro;
  return servicio.icono || ICONOS_FALLBACK[servicio.tipo_servicio] || ICONOS_FALLBACK.otro;
};

export const formatearFecha = (fecha) => {
  if (!fecha) return 'N/A';
  try {
    return new Date(fecha).toLocaleDateString('es-VE', {
      year: 'numeric', month: '2-digit', day: '2-digit'
    });
  } catch {
    return fecha;
  }
};

export default {
  // CRUD
  obtenerServiciosPublicos,
  obtenerServiciosPublicosActivos,
  obtenerServicioPublicoPorId,
  obtenerServiciosPublicosPorTipo,
  crearServicioPublico,
  actualizarServicioPublico,
  eliminarServicioPublico,
  verificarNombreServicioPublico,
  // Constantes
  TIPOS_DISPONIBLES,
  COLORES_FALLBACK,
  ICONOS_FALLBACK,
  // Helpers
  getColorServicio,
  getIconoServicio,
  formatearFecha
};